<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleProductDeleted.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleProductDeleted.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <button></button>
          <div class="d-flex">
            <DatePicker
              v-model="rangeDate"
              type="datetimerange"
              format="dd-MM-yyyy HH:mm"
              style="width: 300px"
              @on-ok="dateRangeChange"
            ></DatePicker>

            <Input
              v-model="search"
              :placeholder="$t('saleProductDeleted.search')"
              :style="width"
              @on-focus="() => (width = 'width: 500px')"
              @on-blur="() => (width = 'width: 300px')"
              class="inline-block ml-2"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'stock_out_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.invoice_no }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.order_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.stock_out_detail_deleted
                  ? record.stock_out_detail_deleted.product
                    ? record.stock_out_detail_deleted.product.product_name_en
                    : null
                  : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.stock_out_detail_deleted
                  ? record.stock_out_detail_deleted.product
                    ? record.stock_out_detail_deleted.product.product_name_kh
                    : null
                  : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.stock_out_detail_deleted.quantity }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ record.grand_total }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.created_by_name }}
            </td>

            <td class="ts-whitespace-no-wrap">
              {{ record.counter_name }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.stock_out_detail_deleted.created_date }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  name: 'sale-product-deleted',
  data () {
    return {
      loading: false,
      width: 'width: 300px',
      rangeDate: [
        moment().add(-1, 'day').startOf('day').format('DD-MM-YYYY HH:mm'),
        moment().endOf('day').format('DD-MM-YYYY HH:mm')
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('restaurantSale/saleProductDeleted', [
      'resources',
      'pagination'
    ]),
    search: {
      get () {
        return this.$store.state.restaurantSale.saleProductDeleted.search
      },
      set (newValue) {
        this.$store.commit(
          'restaurantSale/saleProductDeleted/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'restaurantSale/saleProductDeleted/RESET_CURRENT_PAGE'
        )
      }
    },
    columns () {
      return [
        {
          name: this.$t('saleProductDeleted.branch')
        },
        {
          name: this.$t('saleProductDeleted.invoiceNo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleProductDeleted.order'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleProductDeleted.productNameEn')
        },
        {
          name: this.$t('saleProductDeleted.productNameKh')
        },
        {
          name: this.$t('saleProductDeleted.quantiry'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleProductDeleted.amountTotal'),
          style: 'text-align:right'
        },
        {
          name: this.$t('saleProductDeleted.cashierName'),
          style: 'text-align:center'
        },
        {
          name: this.$t('saleProductDeleted.deletedBy')
        },
        {
          name: this.$t('saleProductDeleted.deletedDate')
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/saleProductDeleted/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange () {
      this.$store.commit(
        'restaurantSale/saleProductDeleted/SET_DATE_FROM',
        moment(this.rangeDate[0]).format('DD-MM-YYYY HH:mm')
      )
      this.$store.commit(
        'restaurantSale/saleProductDeleted/SET_DATE_TO',
        moment(this.rangeDate[1]).format('DD-MM-YYYY HH:mm')
      )
      this.fetchData()
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'SALE PRODUCT DELETED',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500)
  }
}
</script>
<style scoped>
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 10px 5px !important;
}
.table thead tr th {
  padding: 10px 5px !important;
}
</style>
